import { render, staticRenderFns } from "./LinkedCompSliderItem.vue?vue&type=template&id=49e9ca4f&scoped=true&"
import script from "./LinkedCompSliderItem.vue?vue&type=script&lang=js&"
export * from "./LinkedCompSliderItem.vue?vue&type=script&lang=js&"
import style0 from "./LinkedCompSliderItem.vue?vue&type=style&index=0&id=49e9ca4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e9ca4f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MtArrowLink: require('/home/bitrix/frontend/components/other/MtArrowLink.vue').default})
